/** Referral program copy and reward amount (keep in sync with backend). */
export const REFERRAL_REWARD_EGP = 10;

export const REFERRAL_HEADLINE = 'Interested to gain more Money?';

export const REFERRAL_BODY =
  `Refer us to your friends using your referral code and gain ${REFERRAL_REWARD_EGP} EGP every time a new user signs up from a different address using your code.`;

export const referralShareMessage = (code) =>
  `Join Flea Marketplace with my referral code ${code}. Sign up from a new address and I earn ${REFERRAL_REWARD_EGP} EGP!`;

export const referralShareUrl = (code) =>
  `https://flea-marketplace.com/register?ref=${encodeURIComponent(code)}`;
